module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "pre"
    }
  }), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squr.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The study of Magic is much more than merely reading some books and lessons. A plethora of teachers and schools have material on the subject of the Tree of Life, and while some of this material is valuable, much of it is worthless when it comes to the question, “What the heck can you do with it?” In the practices prescribed in this book, you are called upon to make a drawing of the Tree of Life and asked to meditate upon the mystical-magical processes described in this book. The real study and work in Magic depends upon you "), _c('i', [_vm._v("doing")]), _vm._v(" the things called for in the books I write. Do not neglect these practices or just do them in passing, but put a great deal of effort and attention into them.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Also, begin to see how your magical studies can be applied to your daily life. Begin to "), _c('i', [_vm._v("think")]), _vm._v(" magical! That is, make your magical knowledge part of the way you see the world and the way you see yourself. As you learn to think magical, you will find that you experience a much greater reality than you ever anticipated. It is like putting on a new pair of eyeglasses—suddenly you see more, and you see more clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Magic does not tell you how you should act. It does not give you sets of rules or commandments. But, as you begin to see things differently, as you think magical, you will begin to make your own determinations of how you should act, and what you should do in given circumstances. Magic places the responsibility for your life right on your own shoulders. But it also shows you that you have the power to make your life what you want it to be! Power and responsibility always go hand-in-hand, in Magic as in all things.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac0b792","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_preface.vue
// module id = 66
// module chunks = 0